import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {
  Login,
  CustomerCreateForm,
  CustomerDashboard,
  CustomerEditForm,
  Home,
  Dashboard,
  Customers,
  Measurements,
  EditMeasurement,
  Logout,
} from "./pages";
import { getUserToken } from "./helpers";
import jwtDecode from "jwt-decode";
import { Header, Sidebar } from "./components";

function App() {
  useEffect(() => {
    updateToken();
    setLoading(false);

    return function cleanup() {};
  }, []);

  const updateToken = () => {
    let token = getUserToken();
    if (token) {
      const user = jwtDecode(token);
      setUser(user);
    }
  };

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState();

  if (loading === true) {
    return <div></div>;
  }

  const handleLogout = () => {
    localStorage.removeItem("user");
    updateToken();
    window.location.href = "/";
  };

  if (user) {
    // Logout if token is expired
    if (user.exp <= Math.floor(Date.now() / 1000)) {
      handleLogout();
    }
  }

  return (
    <Router>
      {user == null && (
        <Switch>
          <Route path="/Login">
            <Login updateToken={updateToken} />
          </Route>
          <Route exact path="/">
            <Login updateToken={updateToken} />
          </Route>
        </Switch>
      )}
      {user && (
        <div className="main">
          {/* Header */}
          <Header user={user} />

          {/* Contentpane */}
          <div className="content">
            {/* Sidebar */}
            <Sidebar user={user} />

            {/* Container -> Routes */}
            <div className="container">
              {/* Routes for admin user */}
              {user.user_type == 2 && (
                <Switch>
                  <Route
                    path="/customers/create"
                    component={CustomerCreateForm}
                  />
                  <Route exact path="/" component={Home} />
                  <Route exact path="/measurements" component={Measurements} />
                  <Route exact path="/customers" component={Customers} />
                  <Route
                    path="/customers/edit/:customerId?"
                    component={CustomerEditForm}
                  />
                  <Route path="/dashboard/:locationId?" component={Dashboard} />
                  <Route
                    path="/measurements/edit/:measurementId"
                    component={EditMeasurement}
                  />
                </Switch>
              )}
              {/* Routes for customers */}
              {user.user_type == 1 && (
                <Switch>
                  <Route
                    path="/"
                    render={(props) => (
                      <CustomerDashboard {...props} user={user} />
                    )}
                  />
                </Switch>
              )}
              {/* Universal routes */}
              <Route
                path="/logout"
                render={(props) => (
                  <Logout {...props} handleLogout={handleLogout} />
                )}
              />
              {/* <Route path="/table/:category" component={Tableview} /> */}
              {/* <Route
                path="/details/:category/:itemId"
                component={Detailsview}
              /> */}
            </div>
          </div>
        </div>
      )}
    </Router>
  );
}

export default App;
